export default "__VITE_ASSET__Xzb3lmb7__"